"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6414],{

/***/ 36414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EW": function() { return /* binding */ getStories; },
/* harmony export */   "vd": function() { return /* binding */ getStoriesByCategory; }
/* harmony export */ });
/* unused harmony exports getLatestStories, getCategories, getTags, getBoltPost, getPost, getStoryBySlug, getReferral, getPromotion, getCaseStudy, getCaseStudies, getJd, getCareers, getAllStorySlugs, getVisibleStorySlugs, getStoriesBySlug, getLatestPostsByTag, getAllJsWithSlug, getAllPostsWithSlug */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23842);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35230);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* provided dependency */ var process = __webpack_require__(27061);


var API_URL = "https://cms.hiredigital.com/graphql";
var cache = new Map();
function fetchAPI(query) {
    return _fetchAPI.apply(this, arguments);
}
function _fetchAPI() {
    _fetchAPI = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(query) {
        var variables, headers, res, json, _args = arguments;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    variables = (_args.length > 1 && _args[1] !== void 0 ? _args[1] : {}).variables;
                    headers = {
                        "Content-Type": "application/json"
                    };
                    if (process.env.WORDPRESS_AUTH_REFRESH_TOKEN) {
                        headers["Authorization"] = "Bearer ".concat(process.env.WORDPRESS_AUTH_REFRESH_TOKEN);
                    }
                    _ctx.next = 5;
                    return fetch(API_URL, {
                        method: "POST",
                        headers: headers,
                        body: JSON.stringify({
                            query: query,
                            variables: variables
                        })
                    });
                case 5:
                    res = _ctx.sent;
                    _ctx.next = 8;
                    return res.json();
                case 8:
                    json = _ctx.sent;
                    if (!json.errors) {
                        _ctx.next = 12;
                        break;
                    }
                    console.error(json.errors);
                    throw new Error("Failed to fetch API");
                case 12:
                    return _ctx.abrupt("return", json.data);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _fetchAPI.apply(this, arguments);
}
function getLatestStories() {
    return _getLatestStories.apply(this, arguments);
}
function _getLatestStories() {
    _getLatestStories = _async_to_generator(regeneratorRuntime.mark(function _callee() {
        var cacheData, data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!cache.has("LatestStoryQuery")) {
                        _ctx.next = 3;
                        break;
                    }
                    cacheData = cache.get("LatestStoryQuery");
                    return _ctx.abrupt("return", cacheData === null || cacheData === void 0 ? void 0 : cacheData.posts);
                case 3:
                    _ctx.next = 5;
                    return fetchAPI("\n    query LatestStoryQuery {\n      posts(first: 3, where: {postSettingVisible: true}) {\n        nodes {\n          id\n          title\n          slug\n          excerpt\n          tags {\n            nodes {\n              id\n              name\n              slug\n            }\n          }\n          date\n          featuredImage {\n            node {\n              sourceUrl\n              srcSet\n              sizes\n              mediaDetails {\n                height\n                width\n              }\n            }\n          }\n          author {\n            node {\n              name\n            }\n          }\n\n        }\n      }\n    }\n    ");
                case 5:
                    data = _ctx.sent;
                    cache.set("LatestStoryQuery", data);
                    return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : data.posts);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getLatestStories.apply(this, arguments);
}
function getCategories() {
    return _getCategories.apply(this, arguments);
}
function _getCategories() {
    _getCategories = _async_to_generator(regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetchAPI("\n    query CategoryQuery {\n      categories {\n        nodes {\n          id\n          name\n          slug\n          uri\n        }\n      }\n    }\n  ");
                case 2:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : data.categories);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getCategories.apply(this, arguments);
}
function getTags() {
    return _getTags.apply(this, arguments);
}
function _getTags() {
    _getTags = _async_to_generator(regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetchAPI("\n    query TagQuery {\n      tags {\n        nodes {\n          id\n          name\n          slug\n          uri\n        }\n      }\n    }\n  ");
                case 2:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : data.tags);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getTags.apply(this, arguments);
}
function getBoltPost(slug) {
    return _getBoltPost.apply(this, arguments);
}
function _getBoltPost() {
    _getBoltPost = _async_to_generator(regeneratorRuntime.mark(function _callee(slug) {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetchAPI("\n    query BoltPostQuery($slug: ID!) {\n      boltPost(id: $slug, idType: SLUG) {\n        id\n        title\n        slug\n        content\n        excerpt\n        date\n        featuredImage {\n          node {\n            uri\n            mediaItemUrl\n            sourceUrl\n            srcSet\n            sizes\n            mediaDetails {\n              height\n              width\n            }\n          }\n        }\n        tags {\n          nodes {\n            name\n            slug\n          }\n        }\n        categories {\n          nodes {\n            name\n            slug\n          }\n        }\n        author {\n          node {\n            name\n          }\n        }\n        date\n        modified\n        authorId\n        seo {\n          canonical\n          focuskw\n          metaDesc\n          metaKeywords\n          metaRobotsNoindex\n          metaRobotsNofollow\n          opengraphAuthor\n          opengraphDescription\n          opengraphPublishedTime\n          opengraphModifiedTime\n          opengraphPublisher\n          opengraphImage {\n            sourceUrl\n          }\n          opengraphSiteName\n          opengraphTitle\n          opengraphType\n          opengraphUrl\n          title\n          twitterDescription\n          twitterTitle\n          twitterImage {\n            sourceUrl\n          }\n        }\n      }\n    }\n  ", {
                        variables: {
                            slug: slug
                        }
                    });
                case 2:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : data.boltPost);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getBoltPost.apply(this, arguments);
}
function getPost(slug) {
    return _getPost.apply(this, arguments);
}
function _getPost() {
    _getPost = _async_to_generator(regeneratorRuntime.mark(function _callee(slug) {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetchAPI("\n    query PostQuery($slug: ID!) {\n      post(id: $slug, idType: SLUG) {\n        id\n        title\n        slug\n        content\n        excerpt\n        featuredImage {\n          node {\n            uri\n            mediaItemUrl\n            sourceUrl\n            srcSet\n            sizes\n            mediaDetails {\n              height\n              width\n            }\n          }\n        }\n        tags {\n          nodes {\n            name\n            slug\n          }\n        }\n        categories {\n          nodes {\n            name\n            slug\n          }\n        }\n        author {\n          node {\n            name\n          }\n        }\n        date\n        modified\n        settings {\n          hidden\n        }\n        authorId\n        blogPostMeta {\n          relatedArticle3\n          relatedArticle2\n          relatedArticle1\n          authorUuid\n        }\n        faqSettings {\n          title\n          faq {\n            answer\n            question\n          }\n        }\n        seo {\n          canonical\n          focuskw\n          metaDesc\n          metaKeywords\n          metaRobotsNoindex\n          metaRobotsNofollow\n          opengraphAuthor\n          opengraphDescription\n          opengraphPublishedTime\n          opengraphModifiedTime\n          opengraphPublisher\n          opengraphImage {\n            sourceUrl\n          }\n          opengraphSiteName\n          opengraphTitle\n          opengraphType\n          opengraphUrl\n          title\n          twitterDescription\n          twitterTitle\n          twitterImage {\n            sourceUrl\n          }\n        }\n      }\n\n      posts(first: 3, where: {postSettingVisible: true}) {\n        nodes {\n          id\n          title\n          slug\n          excerpt\n          tags {\n            nodes {\n              id\n              name\n              slug\n            }\n          }\n          date\n          featuredImage {\n            node {\n              sourceUrl\n              srcSet\n              sizes\n              mediaDetails {\n                height\n                width\n              }\n            }\n          }\n          author {\n            node {\n              name\n            }\n          }\n\n        }\n      }\n    }\n\n  ", {
                        variables: {
                            slug: slug
                        }
                    });
                case 2:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getPost.apply(this, arguments);
}
function getStoryBySlug(slug) {
    return _getStoryBySlug.apply(this, arguments);
}
function _getStoryBySlug() {
    _getStoryBySlug = _async_to_generator(regeneratorRuntime.mark(function _callee(slug) {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetchAPI("\n    query SlugPostQuery($slug: ID!) {\n      post(id: $slug, idType: SLUG) {\n        id\n        title\n        slug\n        excerpt\n        tags {\n          nodes {\n            id\n            name\n            slug\n          }\n        }\n        date\n        featuredImage {\n          node {\n            sourceUrl\n            srcSet\n            sizes\n            mediaDetails {\n              height\n              width\n            }\n          }\n        }\n      }\n    }\n  ", {
                        variables: {
                            slug: slug
                        }
                    });
                case 2:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : data.post);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getStoryBySlug.apply(this, arguments);
}
function getReferral(slug) {
    return _getReferral.apply(this, arguments);
}
function _getReferral() {
    _getReferral = _async_to_generator(regeneratorRuntime.mark(function _callee(slug) {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetchAPI("\n    query ReferralQuery($slug: ID!) {\n      referral(id: $slug, idType: SLUG) {\n          id\n          slug\n          title\n          content\n          \n          referralSettings {\n            type\n            requestDetails\n          }\n          referralDetails {\n            offerEndnotes\n            offerDetails\n          }\n          date\n      }\n    }\n  ", {
                        variables: {
                            slug: slug
                        }
                    });
                case 2:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : data.referral);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getReferral.apply(this, arguments);
}
function getPromotion(slug) {
    return _getPromotion.apply(this, arguments);
}
function _getPromotion() {
    _getPromotion = _async_to_generator(regeneratorRuntime.mark(function _callee(slug) {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetchAPI("\n    query PromotionQuery($slug: ID!) {\n      promotion(id: $slug, idType: SLUG) {\n          id\n          slug\n          title\n          content\n          promotionDetails {\n            faq\n            details\n          }\n          date\n      }\n    }\n  ", {
                        variables: {
                            slug: slug
                        }
                    });
                case 2:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : data.promotion);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getPromotion.apply(this, arguments);
}
function getCaseStudy(slug) {
    return _getCaseStudy.apply(this, arguments);
}
function _getCaseStudy() {
    _getCaseStudy = _async_to_generator(regeneratorRuntime.mark(function _callee(slug) {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetchAPI("\n    query CaseStudyQuery($slug: ID!) {\n      caseStudy(id: $slug, idType: SLUG) {\n        id\n        title\n        slug\n        content\n        featuredImage {\n          node {\n            sourceUrl\n            srcSet\n            sizes\n          }\n        }\n        date\n      }\n    }\n  ", {
                        variables: {
                            slug: slug
                        }
                    });
                case 2:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : data.caseStudy);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getCaseStudy.apply(this, arguments);
}
function getCaseStudies(cursor) {
    return _getCaseStudies.apply(this, arguments);
}
function _getCaseStudies() {
    _getCaseStudies = _async_to_generator(regeneratorRuntime.mark(function _callee(cursor) {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetchAPI("\n    query CaseStudyListQuery($cursor: String!) {\n      caseStudies(after: $cursor, first:10) {\n        pageInfo {\n          hasNextPage\n          hasPreviousPage\n          startCursor\n          endCursor\n        }\n        edges {\n          cursor\n          node {\n            id\n            title\n            slug\n            excerpt\n            featuredImage {\n              node {\n                sourceUrl\n                srcSet\n                sizes\n              }\n            }\n            date\n          }\n        }\n      }\n    }\n  ", {
                        variables: {
                            cursor: cursor || ""
                        }
                    });
                case 2:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : data.caseStudies);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getCaseStudies.apply(this, arguments);
}
function getJd(slug) {
    return _getJd.apply(this, arguments);
}
function _getJd() {
    _getJd = _async_to_generator(regeneratorRuntime.mark(function _callee(slug) {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetchAPI("\n    query CareerQuery($slug: ID!) {\n      jd(id: $slug, idType: SLUG) {\n        id\n        title\n        slug\n        content\n        menuOrder\n        excerpt\n        categories {\n          nodes {\n            id\n            name\n          }\n        }\n        date\n      }\n    }\n  ", {
                        variables: {
                            slug: slug
                        }
                    });
                case 2:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : data.jd);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getJd.apply(this, arguments);
}
function getCareers(cursor) {
    return _getCareers.apply(this, arguments);
}
function _getCareers() {
    _getCareers = _async_to_generator(regeneratorRuntime.mark(function _callee(cursor) {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetchAPI("\n    query CareerListQuery($cursor: String!) {\n      jds(after: $cursor, first:10) {\n        pageInfo {\n          hasNextPage\n          hasPreviousPage\n          startCursor\n          endCursor\n        }\n        edges {\n          cursor\n          node {\n            id\n            title\n            slug\n            menuOrder\n            excerpt\n            categories {\n              nodes {\n                id\n                name\n              }\n            }\n            date\n          }\n        }\n      }\n    }\n  ", {
                        variables: {
                            cursor: cursor || ""
                        }
                    });
                case 2:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : data.jds);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getCareers.apply(this, arguments);
}
function getStories(cursor) {
    return _getStories.apply(this, arguments);
}
function _getStories() {
    _getStories = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(cursor) {
        var data;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetchAPI("\n    query PostListQuery($cursor: String!) {\n      posts(after: $cursor, first:10, where: {postSettingVisible: true}) {\n        pageInfo {\n          hasNextPage\n          hasPreviousPage\n          startCursor\n          endCursor\n        }\n        edges {\n          cursor\n          node {\n            id\n            title\n            slug\n            date\n            excerpt\n            tags {\n              nodes {\n                id\n                name\n                slug\n              }\n            }\n            author {\n              node {\n                name\n              }\n            }\n            featuredImage {\n              node {\n                sourceUrl\n                srcSet\n                sizes\n                mediaDetails {\n                  sizes {\n                    sourceUrl\n                    height\n                    width\n                    file\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  ", {
                        variables: {
                            cursor: cursor || ""
                        }
                    });
                case 2:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : data.posts);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getStories.apply(this, arguments);
}
function getAllStorySlugs() {
    return _getAllStorySlugs.apply(this, arguments);
}
function _getAllStorySlugs() {
    _getAllStorySlugs = _async_to_generator(regeneratorRuntime.mark(function _callee() {
        var ref, data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return fetchAPI("\n    query PostSlugsQuery {\n      posts(first: 1000) {\n        nodes {\n          slug\n        }\n      }\n    }\n  ");
                case 3:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : (ref = data.posts) === null || ref === void 0 ? void 0 : ref.nodes);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getAllStorySlugs.apply(this, arguments);
}
function getVisibleStorySlugs() {
    return _getVisibleStorySlugs.apply(this, arguments);
}
function _getVisibleStorySlugs() {
    _getVisibleStorySlugs = _async_to_generator(regeneratorRuntime.mark(function _callee() {
        var ref, data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return fetchAPI("\n    query PostSlugsQuery {\n      posts(first: 1000, where: {postSettingVisible: true}) {\n        nodes {\n          slug\n        }\n      }\n    }\n  ");
                case 3:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : (ref = data.posts) === null || ref === void 0 ? void 0 : ref.nodes);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getVisibleStorySlugs.apply(this, arguments);
}
function getStoriesBySlug(slugs) {
    return _getStoriesBySlug.apply(this, arguments);
}
function _getStoriesBySlug() {
    _getStoriesBySlug = _async_to_generator(regeneratorRuntime.mark(function _callee(slugs) {
        var ref, slugStr, ref1, cacheData, data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    slugStr = slugs.join(", ");
                    if (!cache.has("SlugPostsQuery-".concat(slugStr))) {
                        _ctx.next = 8;
                        break;
                    }
                    ;
                    _ctx.next = 6;
                    return cache.get("SlugPostsQuery-".concat(slugStr));
                case 6:
                    cacheData = _ctx.sent;
                    return _ctx.abrupt("return", cacheData === null || cacheData === void 0 ? void 0 : (ref1 = cacheData.posts) === null || ref1 === void 0 ? void 0 : ref1.nodes);
                case 8:
                    _ctx.next = 10;
                    return fetchAPI("\n    query SlugPostsQuery($slugs: String!) {\n      posts(where: {slugIn: $slugs}) {\n        nodes {\n          id\n          title\n          slug\n          excerpt\n          tags {\n            nodes {\n              id\n              name\n              slug\n            }\n          }\n          blogPostMeta {\n            authorUuid\n          }\n          featuredImage {\n            node {\n              sourceUrl\n              srcSet\n              sizes\n            }\n          }\n          date\n          author {\n            node {\n              name\n            }\n          }\n        }\n      }\n    }\n  ", {
                        variables: {
                            slugs: slugStr
                        }
                    });
                case 10:
                    data = _ctx.sent;
                    // console.log(`Setting cached SlugPostsQuery-${slugStr}`);
                    cache.set("SlugPostsQuery-".concat(slugStr), data);
                    return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : (ref = data.posts) === null || ref === void 0 ? void 0 : ref.nodes);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getStoriesBySlug.apply(this, arguments);
}
function getLatestPostsByTag(tagName) {
    return _getLatestPostsByTag.apply(this, arguments);
}
function _getLatestPostsByTag() {
    _getLatestPostsByTag = _async_to_generator(regeneratorRuntime.mark(function _callee(tagName) {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetchAPI("\n    query LatestTagPostsQuery($tagName : String!)  {\n      posts(first: 4,  where: { tag: $tagName } ) {\n        nodes {\n          id\n          title\n          content\n          excerpt\n          slug\n          date\n          featuredImage {\n            node {\n              id\n              sourceUrl\n              srcSet\n              sizes\n            }\n          }\n          tags {\n            nodes {\n              id\n              name\n              slug\n            }\n          }\n          categories {\n           nodes {\n              id\n              name\n              slug\n            }\n          }\n          author {\n            node {\n              name\n            }\n          }\n        }\n      }\n    }\n  ", {
                        variables: {
                            tagName: tagName
                        }
                    });
                case 2:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : data.posts);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getLatestPostsByTag.apply(this, arguments);
}
function getStoriesByCategory(cursor, categoryName) {
    return _getStoriesByCategory.apply(this, arguments);
}
function _getStoriesByCategory() {
    _getStoriesByCategory = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(cursor, categoryName) {
        var data;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetchAPI("\n    query PostListByCategoryQuery($cursor: String!, $categoryName : String!) {\n      posts(after: $cursor, first: 10, where: {postSettingVisible: true, categoryName: $categoryName}) {\n        pageInfo {\n          hasNextPage\n          hasPreviousPage\n          startCursor\n          endCursor\n        }\n        edges {\n          cursor\n          node {\n            id\n            title\n            slug\n            date\n            excerpt\n            tags {\n              nodes {\n                id\n                name\n                slug\n              }\n            }\n            featuredImage {\n              node {\n                sourceUrl\n                srcSet\n                sizes\n              }\n            }\n          }\n        }\n      }\n    }\n  ", {
                        variables: {
                            cursor: cursor || "",
                            categoryName: categoryName
                        }
                    });
                case 2:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : data.posts);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getStoriesByCategory.apply(this, arguments);
}
/////////////////////////////////////////////////////////////////
// export async function getPreviewPost(id, idType = 'DATABASE_ID') {
//   const data = await fetchAPI(
//     `
//     query PreviewPost($id: ID!, $idType: PostIdType!) {
//       post(id: $id, idType: $idType) {
//         databaseId
//         slug
//         status
//       }
//     }`,
//     {
//       variables: { id, idType },
//     }
//   );
//   return data.post;
// }
function getAllJsWithSlug() {
    return _getAllJsWithSlug.apply(this, arguments);
}
function _getAllJsWithSlug() {
    _getAllJsWithSlug = _async_to_generator(regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetchAPI("\n    {\n      jds(first: 10000) {\n        edges {\n          node {\n            slug\n          }\n        }\n      }\n    }\n  ");
                case 2:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : data.jds);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getAllJsWithSlug.apply(this, arguments);
}
function getAllPostsWithSlug() {
    return _getAllPostsWithSlug.apply(this, arguments);
}
function _getAllPostsWithSlug() {
    _getAllPostsWithSlug = _async_to_generator(regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetchAPI("\n    {\n      posts(first: 10000) {\n        edges {\n          node {\n            slug\n          }\n        }\n      }\n    }\n  ");
                case 2:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : data.posts);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getAllPostsWithSlug.apply(this, arguments);
}


/***/ }),

/***/ 23842:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ })

}]);